import { render } from "./InvestasiDetailStatus.vue?vue&type=template&id=4bee6510"
import script from "./InvestasiDetailStatus.vue?vue&type=script&lang=js"
export * from "./InvestasiDetailStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__